import React from 'react';

interface EditorialFloatFigureProps {
  src: string;
  alt: string;
  className?: string;
}

/** Imagen flotante a la derecha — el texto envuelve como en un libro de texto. */
export function EditorialFloatFigure({ src, alt, className = '' }: EditorialFloatFigureProps) {
  return (
    <figure
      className={[
        'editorial-float-figure',
        'float-right w-1/3 max-w-xs ml-6 mb-4 shrink-0',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <img
        src={src}
        alt={alt}
        className="editorial-float-figure__img block h-auto w-full max-h-64 rounded-xl border border-slate-200 object-cover shadow-sm"
      />
    </figure>
  );
}
